// Tailwind config (moved verbatim from inline <script id="tailwind-config">)
tailwind.config = {
    darkMode: "class",
    theme: {
        extend: {
            "colors": {
                "tertiary-fixed": "#ffdea6",
                "surface-container-lowest": "#ffffff",
                "on-error": "#ffffff",
                "surface-dim": "#dddad1",
                "primary-container": "#414833",
                "on-secondary": "#ffffff",
                "primary-fixed-dim": "#c2caae",
                "on-surface": "#1c1c16",
                "surface-container-low": "#f7f3ea",
                "on-primary": "#ffffff",
                "error": "#ba1a1a",
                "on-secondary-fixed": "#3f0300",
                "surface-variant": "#e6e2d9",
                "primary": "#2b321e",
                "on-error-container": "#93000a",
                "on-surface-variant": "#46483f",
                "surface": "#fdf9f0",
                "on-secondary-fixed-variant": "#842414",
                "on-primary-container": "#afb69c",
                "surface-container": "#f1eee5",
                "outline-variant": "#c7c7bd",
                "outline": "#76786f",
                "tertiary-fixed-dim": "#f5be4e",
                "on-primary-fixed-variant": "#424934",
                "primary-fixed": "#dee6c9",
                "secondary": "#a53b29",
                "surface-container-high": "#ece8df",
                "on-tertiary-container": "#e0ab3d",
                "tertiary-container": "#5c4100",
                "on-secondary-container": "#711608",
                "background": "#fdf9f0",
                "surface-tint": "#5a614b",
                "error-container": "#ffdad6",
                "inverse-surface": "#31302b",
                "secondary-fixed-dim": "#ffb4a6",
                "secondary-container": "#fe7d65",
                "surface-container-highest": "#e6e2d9",
                "secondary-fixed": "#ffdad3",
                "tertiary": "#402c00",
                "on-tertiary": "#ffffff",
                "inverse-on-surface": "#f4f0e7",
                "inverse-primary": "#c2caae",
                "on-primary-fixed": "#171e0c",
                "on-background": "#1c1c16",
                "on-tertiary-fixed-variant": "#5d4200",
                "surface-bright": "#fdf9f0",
                "on-tertiary-fixed": "#271900"
            },
            "borderRadius": {
                "DEFAULT": "0.25rem",
                "lg": "0.5rem",
                "xl": "0.75rem",
                "full": "9999px"
            },
            "spacing": {
                "section-gap-desktop": "120px",
                "section-gap-mobile": "64px",
                "unit": "8px",
                "gutter": "24px",
                "editorial-inset": "10%"
            },
            "fontFamily": {
                "display-lg-mobile": ["Michelia"],
                "display-lg": ["Michelia"],
                "headline-md": ["Montserrat"],
                "script-accent": ["Beau Rivage", "Romantic Couple", "cursive"],
                "body-lg": ["Montserrat"],
                "body-sm": ["Montserrat"],
                "label-caps": ["Montserrat"]
            },
            "fontSize": {
                "display-lg-mobile": ["36px", { "lineHeight": "1.2", "fontWeight": "400" }],
                "display-lg": ["48px", { "lineHeight": "1.1", "letterSpacing": "-0.02em", "fontWeight": "400" }],
                "headline-md": ["22px", { "lineHeight": "1.4", "letterSpacing": "0.05em", "fontWeight": "500" }],
                "script-accent": ["40px", { "lineHeight": "1", "fontWeight": "400" }],
                "body-lg": ["16px", { "lineHeight": "1.6", "fontWeight": "400" }],
                "body-sm": ["14px", { "lineHeight": "1.6", "fontWeight": "400" }],
                "label-caps": ["12px", { "lineHeight": "1", "letterSpacing": "0.1em", "fontWeight": "600" }]
            }
        }
    }
};

// Scroll Animation Script (moved verbatim from inline <script> at end of body)
document.addEventListener("DOMContentLoaded", () => {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.fade-in-up').forEach(element => {
        observer.observe(element);
    });

    // Header shrink effect
    const header = document.getElementById('main-header');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header.classList.add('py-2', 'shadow-sm');
            header.classList.remove('py-4');
        } else {
            header.classList.add('py-4');
            header.classList.remove('py-2', 'shadow-sm');
        }
    });
});
function initHeaderScrollEffect(root) {
  var header = root.querySelector("#top-nav");
  if (!header) return function () {};

  function onScroll() {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  window.addEventListener("scroll", onScroll);

  return function destroy() {
    window.removeEventListener("scroll", onScroll);
  };
}
